export const QuarterWrapper: React.FC = ({ children }) => (
  <div className="column is-one-quarter px-5 py-0 mt-3 mb-5 is-flex is-flex-direction-column">
    {children}
  </div>
)